module.exports = __webpack_public_path__ + "img/love-heart.812d57c3.png";